import * as React from "react";
import {
    UserGroupService,
    USER_GROUP_SERVICE_NAME,
} from "../../../service/admin/UserGroupService";
import {RouterView, LoadingViewState} from "../RouterView";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {UserGroup, GroupPermission, PermissionCategory} from "../../../../generated/protocol";
import * as _ from "lodash";


export interface State extends LoadingViewState {
    userGroup?: UserGroup;
    categories?: String[];

}

interface Props {
    params: { id: string }
}

const initialState = {loading: true, userGroup: {groupAccess: {}}, categories: []};

export class UserGroupView extends RouterView<Props, State> {
    userGroupService: UserGroupService;

    constructor(props) {
        super(props);
        this.state = Object.assign(this.state, initialState);
        this.userGroupService = AppCtx.resolve<UserGroupService>(USER_GROUP_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        if (this.props.params.id != "new") {
            return this.fetchData();
        } else {
            return undefined;
        }
    }

    componentDidUpdate(prevProps: Props, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.setState(initialState);
            this.refreshContent();
        }
    }

    private fetchData() {
        return Promise.all<any>([
                this.userGroupService.getEntity(this.props.params.id),
                this.userGroupService.listPermissionCategories()
            ]
        ).then(results => {
            this.setState({userGroup: (results[0] as UserGroup), categories: results[1] as string[]});
        });
    };

    isEnabled(category: string) {
        var groupAccess = this.state.userGroup.groupAccess;
        for (var key in groupAccess) {
            let gp: GroupPermission = groupAccess[key];
            if (gp.category == category) {
                return true;
            }
        }
        return false;
    }

    hasWriteAccess(category: string) {
        let enabled = this.isEnabled(category);
        if (!enabled) {
            return false;
        }

        var groupAccess = this.state.userGroup.groupAccess;
        for (var key in groupAccess) {
            let gp: GroupPermission = groupAccess[key];
            if (gp.category == category && gp.writeAccess == true) {
                return true;
            }
        }
        return false;
    }

    togglePath(cat: string) {
        var userGroup = _.cloneDeep(this.state.userGroup);

        if (userGroup.groupAccess[cat]) {
            delete userGroup.groupAccess[cat];
        } else {
            userGroup.groupAccess[cat] = {category: cat as PermissionCategory, writeAccess: false};
        }

        this.setState({userGroup: userGroup});
    }

    toggleWriteAccess(cat: string) {
        var userGroup: UserGroup = _.cloneDeep(this.state.userGroup);

        if (userGroup.groupAccess[cat]) {
            userGroup.groupAccess[cat].writeAccess = !userGroup.groupAccess[cat].writeAccess;
        } else {
            userGroup.groupAccess[cat] = {category: cat as PermissionCategory, writeAccess: true};
        }

        this.setState({userGroup: userGroup});
    }

    getCategories() {
        if (this.state.categories == null) {
            return [];
        }
        return this.state.categories.map((category: string) => {
            return (

                <tr key={category}>
                    <td><input type="checkbox" onClick={this.togglePath.bind(this, category)}
                               checked={this.isEnabled(category)}/></td>
                    <td><input type="checkbox" onClick={this.toggleWriteAccess.bind(this, category)}
                               checked={this.hasWriteAccess(category)}/></td>
                    <td>{category}</td>
                </tr>

            );
        })
    }

    clearAll() {
        let ug = _.cloneDeep(this.state.userGroup);
        ug.groupAccess = {};
        this.setState({userGroup: ug});
    }

    onSubmit(e: React.FormEvent) {
        e.preventDefault();
        this.userGroupService.save(this.state.userGroup).then(userGroup => {
            if (this.props.params.id == "new") {
                this.navigate("/user-group/" + userGroup.nameId);
            } else {
                this.setState({userGroup: userGroup})
            }
        }).catch(error => {
            console.error("Unable to save user group", this.state.userGroup);
        });
    }

    update(name: string, event: React.FormEvent) {
        var ug = _.clone(this.state.userGroup);
        _.set(ug, name, (event.target as any).value);
        this.setState({userGroup: ug});
    }

    renderContent() {
        return (
            <div>
                <form className="form-horizontal" onSubmit={this.onSubmit.bind(this)}>
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>{this.state.userGroup.name}
                                            <small>{this.state.userGroup.nameId}.</small>
                                        </h5>
                                    </div>
                                    <div className="ibox-content">

                                        <div className="form-group">
                                            <label className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                                <input type="text" value={this.state.userGroup.name}
                                                       onChange={this.update.bind(this, "name")}
                                                       className="form-control"/>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="col-sm-2 control-label">Name Id</label>
                                            <div className="col-sm-10">
                                                <input type="text" value={this.state.userGroup.nameId}
                                                       onChange={this.update.bind(this, "nameId")}
                                                       className="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Available Categories</h5>
                                    </div>

                                    <div className="ibox-content">
                                        <button className="btn btn-primary" onClick={this.clearAll.bind(this)}>Clear
                                            All
                                        </button>
                                        <table className="table table-hover">
                                            <thead>
                                            <tr>
                                                <th style={{width: "100px"}}>Read Access</th>
                                                <th style={{width: "100px"}}>Write Access</th>
                                                <th>Permission</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.getCategories()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Apply Changes</h5>
                                    </div>
                                    <div className="ibox-content">
                                        <div className="form-group">
                                            <button className="btn btn-white" type="submit">Cancel</button>
                                            <button className="btn btn-primary" type="submit">Save changes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </form>
            </div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/app/ui/view/user/UserGroupView.tsx